interface IEligibilityFormula {
  monthlyIncome: number;
  existingEmi: number;
  noOfMonths: number;
  rateOfInterest: number;
}

export const PERSONAL_LOAN_ELIGIBILITY_FORMULA = ({
  monthlyIncome,
  noOfMonths,
  rateOfInterest,
  existingEmi,
}: IEligibilityFormula) => {
  const monthlyIncomeData = Number(monthlyIncome);
  const noOfMonthsData = Number(noOfMonths);
  const rateOfInterestData = Number(rateOfInterest) / 100;
  const existingEMIData = Number(existingEmi);

  if (
    monthlyIncomeData <= 0 ||
    existingEMIData < 0 ||
    noOfMonthsData <= 0 ||
    rateOfInterestData <= 0
  ) {
    return {
      eligibleLoanAmount: 0,
      estimatedEmi: 0,
    };
  }
  const maxEligibleEmi = 0.5 * monthlyIncomeData;
  const availableEMI = maxEligibleEmi - existingEMIData;

  const eligibleLoanAmount =
    availableEMI *
    ((Math.pow(1 + rateOfInterestData / 12, noOfMonthsData) - 1) /
      ((rateOfInterestData / 12) *
        Math.pow(1 + rateOfInterestData / 12, noOfMonthsData)));

  const estimatedEmi = monthlyIncomeData * 0.5 - existingEMIData;

  return {
    eligibleLoanAmount: parseFloat(eligibleLoanAmount.toFixed(2)),
    estimatedEmi: parseFloat(estimatedEmi.toFixed(2)),
  };
};
